/** @jsxImportSource @emotion/react */
import { loadPageQuery, createPageQuery, usePageQuery } from '../page-query.ts'
import { createFileRoute } from '@tanstack/react-router'
import { AccountConnectedAppsPage } from '../pages/account-connected-apps.tsx'
import { loadConnectedAppsPage } from '#start/server/account-collections'
import { documentHead } from '../components/document-head.ts'
const pageQuery = createPageQuery(
	'loadConnectedAppsPage',
	loadConnectedAppsPage,
	{ staleTime: 30_000 },
)

export const Route = createFileRoute('/_app/account_/connected-apps')({
	staticData: {
		navigation: { rail: 'account', item: 'connected-apps' },
	},
	context: () => ({ pageQueryInput: {} }),
	loader: ({ context, preload }) =>
		loadPageQuery(
			context.queryClient,
			pageQuery(context.actorKey, context.pageQueryInput),
			preload,
		),
	head: ({ loaderData }) => documentHead(loaderData?.head),
	component: Page,
})
function Page() {
	const { payload } = usePageData()
	const { pageLocation: location } = Route.useRouteContext()
	return (
		<AccountConnectedAppsPage payload={payload} currentHref={location.href} />
	)
}

function usePageData() {
	const { actorKey, pageQueryInput } = Route.useRouteContext()
	return usePageQuery(pageQuery(actorKey, pageQueryInput)).data
}
